import { NgClass, NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy, Component,
} from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { TemplateStageImageComponent } from '@pt/components';
import { IconModule, TimerComponent } from '@hglobal/common';
import { MyMentoringStage } from '@pt/models';

import { StageBaseComponent } from '../abstructions/stage-base.component';

@Component({
  selector: 'pt-mentoring-stage',
  templateUrl: './mentoring-stage.component.html',
  styleUrl: './mentoring-stage.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgClass,
    TranslateModule,
    IconModule,
    TimerComponent,
    TemplateStageImageComponent,
    NgTemplateOutlet,
  ],
})
export class MentoringStageComponent
  extends StageBaseComponent<MyMentoringStage> {
}
